import React from 'react';
import Impersonate from '../../@jumbo/components/Common/authComponents/Impersonate';

const ImpersonatePage = () => <Impersonate variant="standard" wrapperVariant="bgColor" />;

export default ImpersonatePage;
